module.exports = __webpack_public_path__ + "img/footer.94dfe921.png";